import Swiper, {Navigation, Pagination, EffectFade, Controller, Autoplay} from 'swiper';
import {bigSliderAnimation} from "../animations/_sliderAnimations";
Swiper.use([Navigation, Pagination, EffectFade, Controller, Autoplay]);

const settings = {
    "bigSliderSelector": "[js-big-slider]",
    "logosSliderSelector": "[js-logos-slider]",
    "rangeSliderSelector": "[js-range-slider]",
    "newsSliderSelector": "[js-news-slider]",
    "testimonialsContentSliderSelector": "[js-testimonials-content-slider]",
    "testimonialsAuthorSliderSelector": "[js-testimonials-author-slider]",
    "instrumentsSliderSelector": "[js-instruments-slider]"
}

/**
 * Big slider
 * @type {Swiper}
 */
const bigSlider = new Swiper(settings.bigSliderSelector, {
    slidesPerView: 1,
    navigation: {
        nextEl: '.big-slider-next',
        prevEl: '.big-slider-previous',
    },
    on: {
        init: swiper => bigSliderAnimation(),
        slideNextTransitionStart: swiper => bigSliderAnimation(),
        slidePrevTransitionStart: swiper => bigSliderAnimation("previous")
    }
});

/**
 * Logos slider
 * @type {Swiper}
 */
const logosSlider = new Swiper(settings.logosSliderSelector, {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: true,
    autoplay: true,
    breakpoints: {
        768: {
            slidesPerView: 3,
            spaceBetween: 60,
        },
        1200: {
            slidesPerView: 5
        }
    },
});

/**
 * Range slider
 * @type {Swiper}
 */
const rangeSlider = new Swiper(settings.rangeSliderSelector, {
    slidesPerView: 'auto',
    spaceBetween: 40,
    navigation: {
        nextEl: '.range-slider-next',
        prevEl: '.range-slider-previous',
    }
});

/**
 * News slider
 * @type {Swiper}
 */
const newsSlider = new Swiper(settings.newsSliderSelector, {
    slidesPerView: 1.2,
    spaceBetween: 24,
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 60,
        }
    },
    navigation: {
        nextEl: '.news-slider-next',
        prevEl: '.news-slider-previous',
    },
});



/**
 * Testimonials content slider
 * @type {Swiper}
 */
const testimonialsContentElement = document.querySelector(settings.testimonialsContentSliderSelector);
const testimonialsContentSlider = new Swiper(settings.testimonialsContentSliderSelector, {
    slidesPerView: 'auto',
    loop: true,
    navigation: {
        nextEl: '.testimonials-content-slider-next',
        prevEl: '.testimonials-content-slider-previous',
    }
});

/**
 * Testimonials author slider
 * @type {Swiper}
 */
const testimonialsAuthorElement = document.querySelector(settings.testimonialsAuthorSliderSelector);
const testimonialsAuthorSlider = new Swiper(settings.testimonialsAuthorSliderSelector, {
    slidesPerView: 'auto',
    loop: true,
    centeredSlides: true
});

if (testimonialsContentElement && testimonialsAuthorElement) {
    testimonialsContentSlider.controller.control = testimonialsAuthorSlider;
    testimonialsAuthorSlider.controller.control = testimonialsContentSlider;
}

/**
 * Instruments slider
 * @type {Swiper}
 */
const instrumentsSlider = new Swiper(settings.instrumentsSliderSelector, {
    slidesPerView: 'auto',
    spaceBetween: 24,
    navigation: {
        nextEl: '.instruments-slider-next',
        prevEl: '.instruments-slider-previous',
    }
});
